import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Button from "../../../../ui/Button";
import Progress from "../../../../ui/Progress";
import { SmallStateIcon, StateTextColor, StateName } from "../../components/StateStyles";
import { format, parseISO } from 'date-fns';
import ru from 'date-fns/locale/ru';
import {getRequestCard} from "../../store/actions";
import "./style.css";
import InfoDrawer from "../../../../ui/InfoDrawer";
import TitleBox from "../../../../ui/InfoDrawer/components/TitleBox";
import StateBlock from "../../../../ui/InfoDrawer/components/StateBlock";
import DeviderLine from "../../../../ui/InfoDrawer/components/DeviderLine";
import InfoField from "../../../../ui/InfoDrawer/components/InfoField";
import DateRangeBlock from "../../../../ui/InfoDrawer/components/DateRangeBlock";
import IconButton from "@material-ui/core/IconButton";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";

const useStyles = makeStyles(theme => ({
  more: {
    marginTop: 24,
    marginBottom: 80,
    display: "flex",
    justifyContent: "center"
  },
  progress: {
    display: "flex",
    justifyContent: "center"
  },
  closeButton: {
    position: 'absolute',
    left: 0,
    top: 0,
    opacity: 0.5,
    height: 24,
    'text-align': 'left',
    display: "flex",
    alignItems: "flex-start",
    '& .MuiIconButton-root':{
      padding: 0
    }
  }
}));

const formatDate = date =>
    date ? format(parseISO(date), "dd.MM.yyyy", { locale: ru }) : null;

const StudyRequestDrawer = ({
  open,
  requestId,
  history,
  hideLink,
  handleDrawerClose,
  getRequestCard,
  requestCard
}) => {
  const classes = useStyles();
  const [card, setCard] = React.useState(null);

  React.useEffect(() => {
    if (requestId && requestId !== -1) {
      setCard(null);
      getRequestCard(requestId);
    }
  }, [requestId]);

  React.useEffect(() => {
    setCard(requestCard);
  }, [requestCard]);

  const onLinkClick = () => {
    if (requestCard && requestCard.request) {
      history.push(`/work/app/study/request/${requestCard.request.id}`);
    }
  };

  return (
    <InfoDrawer open={open}>
      {card ? <>
          {!hideLink && <div className={classes.closeButton}>
            <IconButton onClick={handleDrawerClose}>
              <ChevronRightIcon/>
            </IconButton>
          </div>}
        <TitleBox title={`Заявка №${card.request.id}`}
                  subtitle={`от ${formatDate(card.request.date)}`}/>
        <StateBlock leftChipLabel={card.request.targetGroup}
                    leftChipBackground="rgba(48,73,103,0.8)"
                    rightChipLabel={StateName(card.request.status)}
                    rightChipBackground={StateTextColor(card.request.status)}
                    rightChipIcon={SmallStateIcon(card.request.status)}/>
        <DeviderLine/>
        <InfoField name="ФИО" value={card.student.studentName} fieldMinWidth="100px"/>
        <InfoField name="Телефон" value={card.student.contactPhone || '-'} fieldMinWidth="100px"/>
        <InfoField name="E-mail" value={card.student.contactEmail || '-'} fieldMinWidth="100px"/>
        <InfoField name="Дата рождения" value={card.student.studentBirthDate ? formatDate(card.student.studentBirthDate) : '-'} fieldMinWidth="100px"/>
        <InfoField name="СНИЛС" value={card.student.snils || '-'} fieldMinWidth="100px"/>
        {card.request.targetAudience === "schoolchild" &&
        <InfoField name="Представитель" value={card.student.contactName} fieldMinWidth="100px"/>}
        <DeviderLine/>
        <InfoField name="Программа/модуль" display={"block"}
                   value={card.plan ? card.plan.name : card.request.programName}/>
        <div className={classes.more}>
          {!hideLink && <Button onClick={onLinkClick}>Открыть заявку</Button>}
        </div>
      </> :
      <div className={classes.progress}>
        <Progress />
      </div>}
    </InfoDrawer>
  );
};

const mapStateToProps = state => ({
  requestCard: state.studyRequests.requestCard
});

const mapDispatchToProps = dispatch => ({
  getRequestCard: id => dispatch(getRequestCard(id))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(StudyRequestDrawer));
